<template>
  <div class="home-page">
    <!-- TODO: this hard-coded width is specific to the header image -->
    <div v-if="$store.state.settings_established && $store.state.session_established && $store.state.user.uuid"
         style="max-width: 1172px; padding-top: 2rem;">

      <div class="columns">
        <div class="column">
          <img class="header-image" src="/assets/member_portal_header_v2.jpg" />
        </div>
      </div>

      <div class="columns">
        <div class="column">
          <router-link to="/patronage"><img src="/assets/member_patronage.jpg" /></router-link>
        </div>
        <div class="column">
          <router-link to="/general-manager/ends-report"><img src="/assets/co-op_ends_report.jpg" /></router-link>
        </div>
        <div class="column">
          <router-link to="/member-engagement"><img src="/assets/member_engagement.jpg" /></router-link>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import appsettings from '@/appsettings'

export default {
    name: 'home',
    data() {
        return {
            appsettings: appsettings,
            exposeHome: false,
        }
    },
    created: function() {
        this.checkUser()
    },
    watch: {
        '$store.state.session_established': 'checkUser',
        '$store.state.settings_established': 'checkUser',
    },
    methods: {

        checkUser() {
            if (this.$store.state.session_established) {
                if (this.$store.state.settings_established) {

                    this.exposeHome = this.$store.state.expose_home
                    if (this.exposeHome) {
                        // make sure logs in first
                        if (!this.$store.state.user.uuid) {
                            this.$router.push('/login')
                        }
                    }

                    if (!this.exposeHome) {
                        // send logged-in users to "benefits" page instead
                        if (this.$store.state.user.uuid) {
                            this.$router.push('/benefits')
                        } else { // no user; send to login page
                            this.$router.push('/login')
                        }
                    }
                }
            }
        },
    },
}
</script>

<style scoped>
.home-page {
    text-align: center;
}
</style>
